<script>

export default {
  name: 'ReferAFriend',
  props: {
    referralAmount: {
      type: String, 
      required: true 
    }
  },
  data() {
    return {
      sender: {
        firstName: '',
        lastName: '',
        email: ''
      },
      recipient: {
        firstName: '',
        lastName: '',
        email: ''
      }
    };
  },
  methods: {
    submitForm() {
      // this.sender // Contains sender fields
      // this.recipient // Contains referral or recipient fields
      return true;
    }
  }
}
</script>
<template>
  <div class="refer-a-friend widget">
    <!-- <h4>Refer-A-Friend</h4>
    <h3>They Save {{ this.referralAmount }}</h3>
    <h3>You Earn {{ this.referralAmount }}</h3> -->
    <b-link v-b-modal.modal-referAFriend class="btn-link"><img src="@/assets/images/refer-a-friend-banner.png" alt="Refer a Friend Banner" width="320" height="130"></b-link>
    <b-modal id="modal-referAFriend" title="Refer a Friend Form" ok-title="Submit Form" @ok="submitForm()">
      <img src="@/assets/images/refer-a-friend.png" alt="Refer a Friend" width="100%">
      <div class="mt-3">
        <form>
          <label for="sender-first-name-input" class="form-label">Your name</label>
          <div class="row mb-3">
            <div class="col">
              <b-form-input
                id="sender-first-name-input"
                type="text"
                v-model="sender.firstName"
                placeholder="First name" 
                aria-label="First name"
              ></b-form-input>
            </div>
            <div class="col">
              <b-form-input
                id="sender-last-name-input"
                type="text"
                v-model="sender.lastName"
                placeholder="Last name" 
                aria-label="Last name"
              ></b-form-input>
            </div>
          </div>
          <div class="mb-3">
            <label for="sender-email-input" class="form-label">Your email address</label>
            <b-form-input
              id="sender-email-input"
              type="text"
              v-model="sender.email"
              placeholder="Email address" 
              aria-label="Email address"
            ></b-form-input>
          </div>
          <label for="recipient-first-name-input" class="form-label">Person you are referring</label>
          <div class="row mb-3">
            <div class="col">
              <b-form-input
                id="recipient-first-name-input"
                type="text"
                v-model="recipient.firstName"
                placeholder="First name" 
                aria-label="First name"
              ></b-form-input>
            </div>
            <div class="col">
              <b-form-input
                id="recipient-last-name-input"
                type="text"
                v-model="recipient.lastName"
                placeholder="Last name" 
                aria-label="Last name"
              ></b-form-input>
            </div>
          </div>
          <label for="recipient-email-input" class="form-label">What is their email address?</label>
          <b-form-input
            id="recipient-email-input"
            type="text"
            v-model="recipient.email"
            placeholder="Email address" 
            aria-label="Email address"
          ></b-form-input>
        </form>
      </div>
    </b-modal>
  </div>
</template>